export default {
  StatisticalAnalysis: 'Statistical Analysis',
  BusinessDataAnalysis: 'Business Data Analysis',
  GatewayServiceMonitor: 'Gateway Service Monitoring',
  NetworkQualityMonitor: 'Network Quality Monitoring',
  NearlyHour: (hour: number) => `Nearly ${hour} hours`,
  SearchGatewayCpePlaceholder: 'Search for device id/device name/gateway name/branch',
  TotalUpStream: 'Total peak bandwidth - upstream',
  TotalDownStream: 'Total peak bandwidth - downstream',
  Bandwidth: 'Bandwidth',
  BandwidthUtilization: 'Bandwidth usage',
  BarChartTitle: 'Branch traffic usage（top20）',
  NICThroughput: 'NIC Throughput',
  NetworkCardPacketLoss: 'NIC packet loss',
  EquipmentLoad: 'Device load',
  CPUUsage: 'CPU usage',
  MemoryUsage: 'Memory usage',
  DiskUsage: 'Disk usage',
  SearchSourceDevice: 'Search source device number/device alias/gateway number/branch office',
  SearchTargetDevice: 'Search target device number/device alias/gateway number/branch office',
  AllProtocol: 'All protocol',
  AlarmList: 'Alert events',
  SelectPhysical: 'Select physical port',
  PortMonitoring: 'Port monitoring',
  EquipmentMonitoring: 'Equipment monitoring',
  GatewayDeviceMonitoring: 'Gateway device monitoring',
  GatewayPortMonitoring: 'Gateway port monitoring',
  BussinessChartTips1: 'To ensure performance, data granularity will increase accordingly with the length of viewing time, which may result in inconsistent peak data in different time periods. You can go to',
  BussinessChartTips2: 'export view details.',
  PublicNetQualityMonitor: 'Public network quality monitoring',
  AddMonitoring: 'Add monitoring',
  AddPublicIPTips: 'Supports configuration of 10 public network IPs, and data can be viewed 24 hours after configuration.',
  DeleteMonitorConfirmTitle: 'Are you sure you want to delete the monitoring configuration?',
  DeleteMonitorConfirmContent: 'Historical monitoring data will not be retained after deletion',
  SearchPublicIP: 'Search public IP/notes',
  DuplicateIP: 'There are duplicate IPs',
  SelectInterface: 'Specify network card',
  SwitchMonitorEvents: 'Monitoring events',
  Open: 'Open',
  Close: 'Close',
}